import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import ToggleButtonGroup from 'components/ToggleButtonGroup'

import Chart from 'pages/paywall/PremiumAdoptionCard/Chart'
import Legend from 'pages/paywall/PremiumAdoptionCard/Legend'
import Card from 'components/Card'

import usePremiumAdoption from 'hooks/usePremiumAdoption'

const TimeSpans = [
  { key: 7, displayValue: 'PAST 7 DAYS' },
  { key: 30, displayValue: 'PAST 30 DAYS' },
  { key: 365, displayValue: 'PAST 365 DAYS' }
]

type Props = {
  className?: string
}

const PremiumAdoptionCard = ({ className = '' }: Props) => {
  const { premiumDealers, arePremiumDealersLoaded } = usePremiumAdoption()
  const [selectedTimeSpan, setSelectedTimeSpan] = useState(TimeSpans[0].key)
  const [newPremiumAdoptionsLegendNames, setNewPremiumAdoptionsLegendNames] = useState([])
  const [existingPremiumAdoptionsLegendNames, setExistingPremiumAdoptionsLegendNames] = useState([])

  const onChangeSelectedTimeSpan = (timeSpan) => {
    setSelectedTimeSpan(timeSpan)
  }

  const onNewPremiumAdoptionsChartLoaded = useCallback((labels) => {
    setNewPremiumAdoptionsLegendNames(labels)
  }, [])

  const onExistingPremiumAdoptionsChartLoaded = useCallback((labels) => {
    setExistingPremiumAdoptionsLegendNames(labels)
  }, [])

  return (
    <Card title="Premium Adoption" {...{ className }} isLoaded={arePremiumDealersLoaded}>
      {premiumDealers && (
        <S.Container>
          <ToggleButtonGroup selectedValue={selectedTimeSpan} values={TimeSpans} onChange={(value) => onChangeSelectedTimeSpan(Number(value))} />
          <S.Charts>
            <Chart variant="new" timeSpanInDays={selectedTimeSpan} premiumDealers={premiumDealers} onChartLoadCallback={onNewPremiumAdoptionsChartLoaded} />
            <Chart variant="existing" timeSpanInDays={selectedTimeSpan} premiumDealers={premiumDealers} onChartLoadCallback={onExistingPremiumAdoptionsChartLoaded} />
          </S.Charts>
          <Legend legendNames={newPremiumAdoptionsLegendNames.concat(existingPremiumAdoptionsLegendNames)} />
        </S.Container>)
      }
    </Card>
  )
}

export default PremiumAdoptionCard

const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
  `,
  Charts: styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-column-gap: 2px;
    width: 100%;
    margin-top: 5px;
  `
}
